import {ReadNewsItemsService} from "./read-items/ReadNewsItemsService";
import {NewsItemService} from "app/news/service/items/NewsItemService";
import {NewsItemDialogService} from "./dialog/NewsItemDialogService";
import {NewsHeadlineIndicatorSourceFactory} from "./source/NewsHeadlineIndicatorSourceFactory";

export default function(parentModule: string): string {
    const moduleName = `${parentModule}.service`;
    return angular.module(moduleName, [])
                  .service(NewsItemDialogService.id, NewsItemDialogService)
                  .service(NewsItemService.id, NewsItemService)
                  .service(ReadNewsItemsService.id, ReadNewsItemsService)
                  .service(NewsHeadlineIndicatorSourceFactory.id, NewsHeadlineIndicatorSourceFactory)
                  .name;
}
